import { postCurations } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  CreateCurationsServiceRequest,
  CreateCurationsServiceResponse,
} from './create-curations.dto';
import {
  CreateCurationsServiceRequestSchema,
  CreateCurationsServiceResponseSchema,
} from './create-curations.dto';

export const createCurationsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CreateCurationsServiceRequestSchema),
    async (request: CreateCurationsServiceRequest): Promise<CreateCurationsServiceResponse> => {
      const response = await postCurations({
        title: request.title,
        description: request.description,
        type: request.curationType,
        goodsNoList: request.goodsNoList.map((goodsNo) => Number(goodsNo)),
        snapIdList: [],
      });

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 생성에 실패했습니다.');
      }

      return {
        success: true,
        curationId: response.data.curationId.toString(),
      };
    },
    validateServiceResponse(CreateCurationsServiceResponseSchema),
  ),
);
